import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { Provider } from "react-redux";
import store from "./store";

import App from "./components/app/App";
import theme from "./theme";

import "./index.scss";

const container = document.getElementById("root");
const root = createRoot(container!); // Remove '!' if not using TypeScript
root.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>
);
